var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#86123e",
    d: "M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1zm0 24c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm2.29-15.51-.67 8.02c-.07.84-.77 1.49-1.62 1.49s-1.55-.65-1.62-1.49l-.67-8.02C13.6 8.15 14.65 7 16 7a2.3 2.3 0 0 1 2.3 2.3c0 .06 0 .13-.01.19z",
    opacity: 1,
    "data-original": "#ff6174",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningB);
export default __webpack_public_path__ + "static/media/warning-b.d3edfb133d6e14a3e7f321834d308079.svg";
export { ForwardRef as ReactComponent };